import React from 'react';
import logo from './icons/logo.png';
import { useTranslation } from 'react-i18next';

export default function Logo() {
  const { t } = useTranslation();

  return <img src={logo} alt={t('Logo')} />;
}
